/**
 * MO Popup Manager - Global popup state management
 * Migrated from src/alpine/store/popup.js
 */
(function () {
  "use strict";

  window.MO = window.MO || {};

  window.MO.popup = {
    visible: false,
    contentId: "",

    show: function (opts) {
      opts = opts || {};
      this.visible = true;
      this.contentId = opts.contentId || "";
      MO.scrollLock.enable();
      MO.bus.emit("popup:show", { contentId: this.contentId });
    },

    hide: function () {
      this.visible = false;
      this.contentId = "";
      MO.scrollLock.disable();
      MO.bus.emit("popup:hide");
    }
  };
})();
